// Theme Presets
import type { Theme } from "types";

const lightTheme: Theme = {
  name: "light",
  body: "#FAFAFA",
  text: "#0A0A0F",
  dark: "#000000",
  secondaryText: "#4A4A5A",
  accentColor: "#00B894",
  accentBright: "#00D4AA",
  projectCard: "#FFFFFF",
  skinColor: "#F7B799",
  skinColor2: "#FCB696",
  imageDark: "#e9e9e9",
  imageClothes: "#e9e9e9",
  avatarMisc: "#f0f0f0",
  avatarShoes: "#d0d0d0",
};

const darkTheme: Theme = {
  name: "dark",
  body: "#0A0A0F",
  text: "#F0F0F5",
  dark: "#000000",
  secondaryText: "#8A8A9A",
  accentColor: "#00D4AA",
  accentBright: "#00F5C4",
  projectCard: "#12121A",
  skinColor: "#F7B799",
  skinColor2: "#FCB696",
  imageDark: "#12121A",
  imageClothes: "#0A0A0F",
  avatarMisc: "#1A1A24",
  avatarShoes: "#2A2A34",
};

export const themes: Record<string, Theme> = {
  light: lightTheme,
  dark: darkTheme,
};

// Function to create a custom theme with dynamic colors
export const createCustomTheme = (
  baseTheme: Theme,
  accentColor: string,
  accentBright: string,
): Theme => {
  return {
    ...baseTheme,
    accentColor,
    accentBright,
  };
};

// Function to get saved theme colors from localStorage
export const getSavedThemeColors = () => {
  try {
    if (globalThis.window === undefined) {
      return null;
    }

    const saved = localStorage.getItem("portfolio-theme-color");
    if (!saved) {
      return null;
    }

    const parsed = JSON.parse(saved) as {
      accentColor?: unknown;
      accentBright?: unknown;
    };

    if (
      typeof parsed.accentColor === "string" &&
      typeof parsed.accentBright === "string"
    ) {
      return {
        accentColor: parsed.accentColor,
        accentBright: parsed.accentBright,
      };
    }

    return null;
  } catch {
    return null;
  }
};
